import jwt from "@/http/requests/auth/jwt"
import moment from "moment"

const getStatisticsRequest = function (payload) {
  let url = ""
  const params = {
    startDate: moment(payload.startDate).format("YYYY-MM-DD"),
    endDate: moment(payload.endDate).format("YYYY-MM-DD"),
    take: 250
  }
  if (payload.retailBranchId) {
    url = `/api/campaign/${payload.idCampaign}/statistics`
    params.dimensionFilter = payload.retailBranchId
    params.dimension = "RetailBranches"
    if (payload.dimension !== "Date") {
      params.secondaryDimension = payload.dimension
    }
  } else if (payload.idCampaign) {
    url = `/api/campaign/${payload.idCampaign}/statistics`

    if (payload.dimension !== "Date") {
      params.dimension = payload.dimension
    }
    if (payload.secondaryDimension) {
      if (payload.secondaryDimension !== "Date") {
        params.secondaryDimension = payload.secondaryDimension
      }
      params.dimensionFilter = payload.dimensionFilter
    }
  } else {
    url = `/api/advertiser/${payload.idAdvertiser}/statistics`

    if (payload.dimension !== "Date") {
      params.dimension = payload.dimension
    }
  }
  return { url, params }
}

export default {
  setDimension ({ commit }, dimension) {
    commit("SET_DIMENSION", dimension)
  },
  setSecondaryDimension ({ commit }, dimension) {
    commit("SET_SECONDARY_DIMENSION", dimension)
  },
  setRange ({ commit }, range) {
    commit("SET_RANGE", range)
  },
  
  fetchStatistics ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.idCampaign) {
        commit("SET_STATISTICS", [])
        resolve({})
      }
      commit("SET_IS_LOADING", true)
      const request = getStatisticsRequest(payload)

      jwt
        .get(request.url, request.params)
        .then((response) => {
          commit("SET_STATISTICS", response.data.items)
          commit("SET_IS_LOADING", false)
          resolve(response)
        })
        .catch((error) => {
          commit("SET_IS_LOADING", false)
          reject(error)
        })
    })
  },
  fetchStatisticsDashboard ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.idCampaign) {
        commit("SET_STATISTICS_DASHBOARD", [])
        resolve({})
        return
      }
      commit("SET_IS_LOADING_DASHBOARD", true)
      const request = getStatisticsRequest(payload)

      jwt
        .get(request.url, request.params)
        .then((response) => {
          commit("SET_STATISTICS_DASHBOARD", response.data.items)
          commit("SET_IS_LOADING_DASHBOARD", false)
          resolve(response)
        })
        .catch((error) => {
          commit("SET_IS_LOADING_DASHBOARD", false)
          reject(error)
        })
    })
  },
  fetchStatisticsMonthComparison ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit("SET_IS_LOADING_MONTH_COMPARISON", true)
      const request = getStatisticsRequest(payload)

      jwt
        .get(request.url, request.params)
        .then((response) => {
          commit("SET_STATISTICS_MONTH_COMPARISON", response.data.items)
          commit("SET_IS_LOADING_MONTH_COMPARISON", false)
          resolve(response)
        })
        .catch((error) => {
          commit("SET_IS_LOADING_MONTH_COMPARISON", false)
          reject(error)
        })
    })
  }
}
